// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__1Gv6Y","question":"Question_question__2CCLQ","description":"Question_description__10A-m"};